<template>
  <a-table
    :rowKey="record => record.limit.id"
    :columns="columns"
    :dataSource="data"
    bordered
  >
    <template slot="Serial">{{ $t('business.label.serial') }}</template>
    <template slot="Uom">{{ $t('business.label.uom') }}</template>
    <template slot="Factor">{{ $t('business.label.factor') }}</template>
    <template slot="Specification">{{ $t('business.label.specification') }}</template>
    <template slot="StorageRoom.name">{{ $t('business.label.storageRoom') }}</template>
    <template slot="Warehouse.name">{{ $t('business.label.warehouseName') }}</template>
    <template slot="LimitType">{{ $t('business.label.limitType') }}</template>
    <template slot="Region">{{ $t('business.label.region') }}</template>
    <template slot="Location.no">{{ $t('business.label.locationNo') }}</template>
    <template slot="Receivable">{{ $t('business.label.receivable') }}</template>
    <template slot="Shippable">{{ $t('business.label.shippable') }}</template>
    <template slot="Ordinal">{{ $t('business.label.ordinal') }}</template>

    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>
    <span slot="limitType" slot-scope="text">
      <span
        v-for="(value,key) in limitTypeData"
        :key="key">
        <span v-if="text===value.ordinal">{{ value.name }}</span>
      </span>
    </span>

    <span slot="receivable" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>

    <span slot="shippable" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
  </a-table>
</template>

<script>
  import {findAll} from '@/api/Api';
  import {exportToExcel} from '@/components/Excel/export/exportFunction'
  import {excelName, filterVal, headerData} from '@/api/dto_js/import/locationForItemBaseData'
  import {nameToOrdinal, ordinalToName, transformData} from '@/api/dto_js/import/transform'
  import {checkFieldType} from '@/utils/field-check'
  import Vue from 'vue'
  import {OPERATOR, WAREHOUSE} from '@/store/mutation-types'

  export default {
    name: 'LocationForItemBaseData',
    data() {
      return {
        data: [],
        executor: Vue.ls.get(OPERATOR),
        warehouse: Vue.ls.get(WAREHOUSE),
        // 表头
        columns: [
          {
            // fixed: 'left',
            scopedSlots: {customRender: 'serial', title: 'Serial'}
          },
          {
            dataIndex: 'pack.uom',
            scopedSlots: {title: 'Uom'}
          },
          {
            dataIndex: 'pack.factor',
            scopedSlots: {title: 'Factor'}
          },
          {
            dataIndex: 'pack.specification',
            scopedSlots: {title: 'Specification'}
          },
          {
            dataIndex: 'storageRoom.name',
            scopedSlots: {customRender: 'storageRoom.name', title: 'StorageRoom.name'}
          },
          {
            dataIndex: 'limit.limitType',
            scopedSlots: {customRender: 'limitType', title: 'LimitType'}
          },
          {
            dataIndex: 'limit.region',
            scopedSlots: {title: 'Region'}
          },
          {
            dataIndex: 'location.no',
            scopedSlots: {title: 'Location.no'}
          },
          {
            dataIndex: 'limit.receivable',
            scopedSlots: {customRender: 'receivable', title: 'Receivable'}
          },
          {
            dataIndex: 'limit.shippable',
            scopedSlots: {customRender: 'shippable', title: 'Shippable'}
          },
          {
            dataIndex: 'limit.ordinal',
            scopedSlots: {title: 'Ordinal'}
          },
          {
            dataIndex: 'warehouse.name',
            scopedSlots: {customRender: 'warehouse.name', title: 'Warehouse.name'}
          }

        ],
        limitTypeData: [],
        regionData: [],
        storageRoomData: []
      }
    },
    mounted() {
      findAll('fieldFactory', {no: 'LIMIT_TYPE'}).then(body => {
        body.dictionaries.forEach(item => {
          this.limitTypeData.push(item)
        })
      })
    },
    methods: {
      getData(data) {
        this.data = data
      },
      exportData() {
        const excelData = JSON.parse(JSON.stringify(this.data))
        for (let x = 0; x < excelData.length; x++) {
          if (excelData[x].storageRoom) {
            excelData[x].storageRoom = excelData[x].storageRoom.name
          }
          if (excelData[x].warehouse) {
            excelData[x].warehouse = excelData[x].warehouse.name
          }
          if (excelData[x].location) {
            excelData[x].location = excelData[x].location.no
          }
          excelData[x].uom = excelData[x].pack.uom
          excelData[x].factor = excelData[x].pack.factor
          excelData[x].specification = excelData[x].pack.specification
          excelData[x].region = excelData[x].limit.region
          excelData[x].receivable = excelData[x].limit.receivable
          excelData[x].shippable = excelData[x].limit.shippable
          excelData[x].ordinal = excelData[x].limit.ordinal
          excelData[x].limitType = excelData[x].limit.limitType
          excelData[x] = ordinalToName(excelData[x], 'limitType', this.limitTypeData)
        }
        // this.$message.info(JSON.stringify(excelData))
        exportToExcel(headerData, filterVal, excelData, excelName)
      },
      transformData(data) {
        // storageRoom尚未转换
        const list = transformData(headerData, filterVal, data)
        // this.$message.info(JSON.stringify(list))
        for (let i = 0; i < list.length; i++) {
          if (list[i].storageRoom) {
            list[i].storageRoom = {name: list[i].storageRoom}
          }
          if (list[i].warehouse) {
            list[i].warehouse = {name: list[i].warehouse}
          }
          if (list[i].location) {
            list[i].location = {no: list[i].location}
          }
          list[i] = nameToOrdinal(list[i], 'limitType', this.limitTypeData)
          list[i].pack = {
            uom: list[i].uom,
            factor: list[i].factor,
            specification: list[i].specification
          }
          list[i].limit = {
            region: list[i].region,
            receivable: list[i].receivable,
            shippable: list[i].shippable,
            ordinal: list[i].ordinal,
            limitType: list[i].limitType
          }
        }
        this.data = list
      },
      save() {

        const arrLocation = []

        this.data.forEach(item => {
          item['id'] = null
          item['version'] = 0

          const map = new Map()
          map.set('type', 'locationLimitPersister')

          // 仓库编号-包装规格-库房编号-限定类型-逻辑区域-货位编号

          map.set('dataId', item.warehouse === null ? this.warehouse.name : item.warehouse.name + '-' + item.pack.specification + '-' + item.storageRoom.name + '-' +
            item.limit.limitType + '-' + item.limit.region + '-' + item.location.no
          )
          map.set('content', item)
          const returnValue = checkFieldType(map)
          arrLocation.push(returnValue)
        })
        // this.$message.info(JSON.stringify(this.data))
        this.$emit('sendSave', arrLocation)
      },
      // save(){
      //   this.data.forEach(item=>{
      //     item['id']=null
      //     item['version']=0
      //   })
      //   // this.$message.info(JSON.stringify(this.data))
      //   this.$emit('sendSave',this.data)
      // },
      clear() {
        this.data = []
      }
    }
  }
</script>

<style scoped>

</style>